import React from "react";
import styles from "./Dunkun.module.css";
import background from "../../../Img/Main/background.png";
const Dunkun = () => {
  return (
    <div className={styles.container}>
      <div className={styles.mimo}>
        <div>
          <div>Dunkun</div>
          <div>CEO</div>
        </div>
      </div>

      <div className={styles.textBox}>
        <div className={styles.textList}>
          <div>
            먼데이오프는 시작부터 글로벌 진출을 목표로하는 회사입니다. 하이퍼
            캐주얼이라는 새롭게 생겨난 모바일 게임 장르에 대해 대한민국에서 가장
            먼저 진출하였고 가장 높은 성적을 달성하고 있습니다.
          </div>
          <br />
          <div>
            시작은 미약해보일지라도 끝은 창대할 겁니다. 개개인의 경력을 키우기
            위해 타이밍도 매우 중요할 거예요. 지금이 먼데이오프에 입사해서 더
            높은 곳으로 가기 위한 중요한 타이밍이 될 겁니다.
          </div>
          <br />
          <div>
            더 높은 곳으로 가기전 빠르게 합류해서 성공을 같이 누리세요.
            먼데이오프에서 인재를 기다립니다.
          </div>
          <br />
        </div>
        <div>Dunkun/ CEO</div>
      </div>
    </div>
  );
};

export default Dunkun;
